import { WhatsNewDialogRedesign } from 'reactApp/components/WhatsNewDialogRedesign/WhatsNewDialogRedesign';
import { renderModalDialog } from 'reactApp/utils/createDialogToolkit';

export const renderWhatsNewDialogRedesign = renderModalDialog(WhatsNewDialogRedesign, 'WhatsNewDialogRedesign');
